import { Skeleton, Stack, Typography, useTheme } from "@mui/material";
import { ProductConfiguration } from "../configurations-list/components/product-configuration";
import { RootState } from "src/store";
import { connect } from "react-redux";
import { useConfiguratorPageT } from "src/translation-hooks/configurator-page";
import { AppliedFilters } from "../filter/components";

const mapStateToProps = (state: RootState) => ({
  configurationsState: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.configurationsState,
  isLoading: state.pageReducer.combinedConfiguratorReducer.configuratorReducer.isLoading
});

const ownActions = {
  //
};

type Props = typeof ownActions & ReturnType<typeof mapStateToProps>;

const ProductsBase = (props: Props) => {
  const { configurationsState, isLoading } = props;

  const theme = useTheme();

  const configuratorPageT = useConfiguratorPageT();

  if (isLoading) {
    return (
      <Stack gap={2}>
        {Array(4)
          .fill(null)
          .map((_, index) => {
            return <Skeleton key={index} height={40} />;
          })}
      </Stack>
    );
  }

  const totalProjectLineItems =
    (configurationsState &&
      configurationsState.configurations.reduce((acc, configuration) => {
        acc += configuration.projectLineItems?.length || 0;
        return acc;
      }, 0)) ||
    0;

  if (!isLoading && configurationsState) {
    return (
      <Stack gap={1}>
        <Stack direction="row" alignItems="center" justifyContent="space-between" mx={1}>
          <Stack>
            <AppliedFilters />
          </Stack>

          {totalProjectLineItems > 0 && (
            <Typography flex="none" variant="subtitle1" color={theme.palette.customColors.darkGrey}>
              {totalProjectLineItems} {totalProjectLineItems > 1 ? configuratorPageT.products : configuratorPageT.product}
            </Typography>
          )}
        </Stack>
        {configurationsState.configurations.length === 0 && (
          <Stack gap={2} mt={2}>
            <Typography variant="subtitle2" color={theme.palette.customColors.darkGrey}>
              {configuratorPageT.noConfigurations}
            </Typography>
            <Typography variant="subtitle1" color={theme.palette.customColors.darkGrey}>
              {configuratorPageT.getStartedByClickingNewConfiguration}
            </Typography>
          </Stack>
        )}
        {configurationsState.configurations.length > 0 && (
          <Stack gap={1}>
            {configurationsState.configurations.map(configuration => {
              return (
                <>
                  {configuration.projectLineItems &&
                    configuration.projectLineItems.map(projectLineItem => {
                      return (
                        <ProductConfiguration
                          key={projectLineItem.projectLineItemId}
                          missingInformation={configuration.missingInformation}
                          projectLineItem={projectLineItem}
                          configurationName={configuration.configurationName}
                          isProductTab
                        />
                      );
                    })}
                </>
              );
            })}
          </Stack>
        )}
      </Stack>
    );
  }

  return <></>;
};

export const Products = connect(mapStateToProps, ownActions)(ProductsBase);
